define('lq/events/actions/downloadFileCommand',[
    'underscore',
    'lq/events/actions/eventAction',
    'lq',
    'lq/responsive',
], function (_, EventAction, lq, responsive) {
    'use strict';

    function DownloadFileCommand(eventData, eventArg) {
        EventAction.call(this, eventData, eventArg);
        this.eventData = eventData;
        return this;
    }

    EventAction.extend(DownloadFileCommand, EventAction);

    DownloadFileCommand.typeName = 'DownloadFileCommand';

    DownloadFileCommand.prototype.getBatchType = function () {
        return EventAction.DO_NOT_BATCH;
    };

    DownloadFileCommand.prototype.execute = function (continuation) {
        var queryString = {
            actionId: this.piping.actionId,
            commandId: this.eventData.command,
            parameters: JSON.stringify(this.piping.parameters.getNonSystemParameters()),
            forceDownload: responsive.isPWA()
        };
        var url = this.piping.url.prepare(lq.getTenantUrl('Export/File'), queryString);
        
        if (this.eventData.openInNewTab) {
            window.open(url + '#toolbar=1');
        } else {
            window.location.href = url;
        }

        continuation();
    };

    return DownloadFileCommand;
});
